import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=1050bcba&scoped=true"
import script from "./AddOrEdit.vue?vue&type=script&lang=js"
export * from "./AddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./AddOrEdit.vue?vue&type=style&index=0&id=1050bcba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050bcba",
  null
  
)

export default component.exports